import store from "@/store";
import { onMounted, onUnmounted, computed } from "vue";
const useCameras = () => {
    onMounted(async () => store.dispatch.cameras.subscribe());
    onUnmounted(async () => store.dispatch.cameras.unsubscribe());
    return {
        cameras: computed(() => store.state.cameras.cameras),
        selectedCameraId: computed(() => store.state.cameras.selectedCamera),
        camera_modus: computed(() => store.state.cameras.modus),
        updateCameras: store.dispatch.cameras.update
    };
};
export default useCameras;
